import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import FlagIcon from 'vue-flag-icon'
import VueTelInput from 'vue-tel-input'
import UUID from 'vue-uuid'
// import 'vue-tel-input/dist/vue-tel-input.css'

Vue.config.productionTip = false
Vue.use(VueTelInput)
Vue.use(FlagIcon)
Vue.use(UUID)
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
